/**------------------------------------------------------
 * Paddle Webhook alert types for subscription
 */
export enum EnumPaddleSubscriptionWebhook {
	SubsCreated				= 'subscription_created',
	SubsUpdated				= 'subscription_updated',
	SubsCancelled			= 'subscription_cancelled',
	SubsPaymentFailed		= 'subscription_payment_failed',
	SubsPaymentSuccess		= 'subscription_payment_succeeded',
	SubsPaymentRefund		= 'subscription_payment_refunded'
}


/**------------------------------------------------------
 * Paddle Webhook alert types for one time payment
 */
export enum EnumPaddleOneTimePaymentWebhook {
	PaymentSucceeded		= 'payment_succeeded',
	PaymentRefunded			= 'payment_refunded',
	OrderProcessingComplete	= 'locker_processed'
}


/**------------------------------------------------------
 * Paddle events status
 */
export enum EnumPaddleSubscriptionEventsStatus {
	SubsActiveStatus		= 'active',
	SubsTrialingStatus		= 'trialing',
	SubsPastDueStatus		= 'past_due',
	SubsPausedStatus		= 'paused',
	SubsDeletedStatus		= 'deleted'
}


/**------------------------------------------------------
 * Paddle Configs
 */
export enum EnumPaddleConfigs {
	IdentifierLength = 32
}
